import React from 'react';
import PageHeader from '../Header/PageHeader';

const NotificationPage = () => {
    return (
        <div>
            <PageHeader title="اعلانات" />
        </div>
    );
};

export default NotificationPage;
